/* eslint-disable max-classes-per-file */

export class MissingArtifactError extends Error {
  public metadata: unknown;

  constructor(message: string, metadata: unknown) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);

    this.metadata = metadata;
  }
}

export class InvalidStateError extends Error {
  public metadata: unknown;

  constructor(message: string, metadata: unknown) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);

    this.metadata = metadata;
  }
}

export class RestrictedAccessError extends Error {
  constructor(message: string, public readonly metadata?: unknown) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
